import changelogData from "../../../../../pages/pos-register/docs/changelog-pos-register.json5";
import * as React from 'react';
export default {
  changelogData,
  React
};